import { render, staticRenderFns } from "./BookmarkScreen.vue?vue&type=template&id=f59338c2&scoped=true&"
import script from "./BookmarkScreen.vue?vue&type=script&lang=ts&"
export * from "./BookmarkScreen.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkScreen.vue?vue&type=style&index=0&id=f59338c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59338c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
